import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import CommentList from './CommentList'
import CommentForm from './CommentForm'
import ReplyButton from './ReplyButton'


import { objectComments } from 'selectors/comments'
import { notificationsGroups } from 'selectors/notifications'

let select = (state, props) => ({
	comments: objectComments(state, props)
  , comment: state.commentBuffer
  , notificationsGroups: notificationsGroups(state, props).notifications || []
})

export class GroupsList extends Component {
	render(){
		let { props } = this
		return(
			<div className="comment-list">
				{R.map(group => <CommentList mode={props.mode} objectID={props.objectID} group={group}/>, R.values(props.notificationsGroups))}
			</div>
		)
	}
}

export default connect(select)(GroupsList)



// WEBPACK FOOTER //
// ./src/components/Communication/GroupsList.js